// Detaillierte Inhalte für Ratgeber-Artikel - Teil 2

export const ratgeberContentPart2 = {
  'einbruchschutz-tueren': {
    sections: [
      {
        title: 'Warum ist Einbruchschutz so wichtig?',
        content: `Alle 2-3 Minuten findet in Deutschland ein Einbruch statt. Die Statistiken des BKA zeigen: Über 40% aller Einbrüche erfolgen über die Haustür oder Wohnungstür. Eine ungesicherte Tür ist für Einbrecher oft in wenigen Sekunden geöffnet – mit einem Schraubendreher, einer Brechstange oder durch das Aufbohren des Zylinders.

Die gute Nachricht: Mehr als 40% aller Einbruchsversuche scheitern an guten Sicherungen. Einbrecher geben auf, wenn sie innerhalb von 2-3 Minuten keinen Erfolg haben. Ihr Ziel ist es, schnell und leise zu arbeiten. Ein effektiver Einbruchschutz schreckt ab und erhöht das Entdeckungsrisiko enorm.

**Die psychologischen Folgen eines Einbruchs:**
Neben dem materiellen Schaden leiden viele Opfer noch Monate oder Jahre unter dem Verlust des Sicherheitsgefühls. Das eigene Zuhause fühlt sich nicht mehr sicher an. Viele Menschen berichten von Schlafstörungen, Angst und dem Gefühl, beobachtet zu werden. Diese psychologischen Schäden sind oft schwerwiegender als der materielle Verlust.

**Kostenaspekt:**
Professioneller Einbruchschutz kostet zwischen 500-2000 €, je nach Umfang. Das klingt viel, ist aber eine Investition fürs Leben. Versicherungen zahlen oft Zuschüsse, und die KfW-Bank fördert Einbruchschutzmaßnahmen mit bis zu 1.600 € Zuschuss (bei Maßnahmen ab 500 €).`
      },
      {
        title: 'Die wichtigsten Schwachstellen einer Tür',
        content: `Professionelle Einbrecher kennen die Schwachstellen jeder Tür. Hier die häufigsten Angriffspunkte:

**1. Der Schließzylinder**
Der Zylinder ist das Herzstück der Tür-Sicherheit und gleichzeitig eine große Schwachstelle. Einfache Zylinder lassen sich innerhalb von 30 Sekunden aufbohren, aufbrechen oder manipulieren ("Lock Picking"). Ein überste hender Zylinder (mehr als 3mm) bietet zusätzliche Angriffsfläche und kann abgebrochen werden.

**2. Das Türblatt und der Rahmen**
Dünne Türblätter (unter 40mm) lassen sich mit einem Stemmeisen leicht aufbrechen. Auch der Türrahmen muss stabil sein – ein schwacher Holzrahmen gibt bei Krafteinwirkung nach.

**3. Das Einsteckschloss**
Einfache Schlösser ohne zusätzliche Verriegelungspunkte bieten wenig Widerstand. Der Riegel kann mit einem Brecheisen  herausgehebelt werden.

**4. Die Scharniere (Bänder)**
Bei nach außen öffnenden Türen können die Scharniere aufgebrochen werden. Bei nach innen öffnenden Türen sind sie von außen zwar nicht sichtbar, aber bei mangelhafter Befestigung trotzdem eine Schwachstelle.

**5. Türspion und Briefschlitz**
Durch den Briefschlitz können Einbrecher mit Werkzeugen den Türgriff von innen betätigen. Ein zu großer oder unsicherer Türspion kann ausgebaut werden, um Zugang zum Innenmechanismus zu bekommen.

**6. Der Türspalt**
Der Spalt zwischen Tür und Rahmen bietet Ansatzpunkte für Hebelwerkzeuge. Je größer der Spalt, desto leichter das Aufhebeln.`
      },
      {
        title: 'Sicherheitstechnik im Überblick',
        content: `Moderne Einbruchschutzsysteme bestehen aus mehreren Komponenten:

**1. Sicherheitszylinder (ab 50 €)**
• **Bohrschutz:** Gehärtete Stahlstifte verhindern das Aufbohren
• **Ziehschutz:** Verhindert das Herausziehen des Zylinders
• **Manipulationsschutz:** Erschwert Lock-Picking
• **Empfehlung:** Zylinder mit VdS-Anerkennung, mindestens Sicherheitsstufe 2
• **Top-Modelle:** ABUS EC660, EVVA MCS, DOM ix 6SR

**2. Mehrfachverriegelung (ab 200 €)**
Statt einem Riegel verriegelt das Schloss an 3, 5 oder 7 Punkten gleichzeitig:
• Oben, Mitte, unten + seitliche Verriegelung
• Deutlich höherer Widerstand gegen Aufhebelversuche
• Schließt mit einem Schlüsseldreh alle Punkte

**3. Panzerriegel (ab 150 €)**
Eine Metallstange, die horizontal über die gesamte Tür verläuft:
• Wird auf der Innenseite montiert
• Verankert die Tür im Mauerwerk
• Verhindert das Aufhebeln extrem effektiv
• **Nachteil:** Nur von innen bedienbar, nicht für Abwesenheit geeignet

**4. Querriegelschloss (ab 250 €)**
Ähnlich wie Panzerriegel, aber mit Zylinder und von außen bedienbar:
• Massive Metallschiene quer über die Tür
• Von außen abschließbar
• Sehr hohe Sicherheit
• Sichtbare Abschreckung

**5. Zusatzschloss (ab 80 €)**
Wird zusätzlich zum Hauptschloss montiert:
• Oberhalb oder unterhalb des Hauptschlosses
• Verdoppelt den Zeitaufwand für Einbrecher
• Einfach nachrüstbar
• Modelle: ABUS 7030, BURG-WÄCHTER E 306

**6. Bandseitensicherung (ab 60 €)**
Sichert die Scharnierseite:
• Verhindert das Aushebeln auf der Bandseite
• Bei nach außen öffnenden Türen essentiell
• Auch Nachrüstung möglich

**7. Schließblech verstärken (ab 30 €)**
Stabile, im Mauerwerk verankerte Schließbleche:
• Verhindern das Herausreißen bei Krafteinwirkung
• Müssen tief (mind. 50mm) im Mauerwerk verankert sein
• Besonders wichtig bei Mehrfachverriegelung

**8. Türspion mit Weitwinkel (ab 15 €)**
• 180° oder mehr Blickwinkel
• HD-Modelle für klare Sicht
• Digitale Modelle mit Kamera und Display

**9. Türkette oder Sperrbügel (ab 20 €)**
• Erlaubt Türöffnung mit Sicherheitsabstand
• Verhindert gewaltsames Aufdrücken
• Nur als Ergänzung, nicht als Hauptsicherung`
      },
      {
        title: 'Widerstandsklassen nach DIN EN 1627',
        content: `Sicherheitstüren und -beschläge werden nach europäischer Norm in Widerstandsklassen (RC = Resistance Class) eingeteilt:

**RC 1N:** 
Basis-Schutz gegen körperliche Gewalt (Tritte, Schulter). 
Widerstandszeit: Wenige Sekunden
**Empfehlung:** Nicht mehr zeitgemäß, besser höhere Klasse wählen

**RC 2:**
Schutz gegen einfache Werkzeuge (Schraubendreher, Zange)
Widerstandszeit: Mindestens 3 Minuten
**Empfehlung:** Minimum für Wohnungstüren und Einfamilienhäuser

**RC 3:**
Schutz gegen professionellere Werkzeuge (Brecheisen, Bohrer)
Widerstandszeit: Mindestens 5 Minuten
**Empfehlung:** Für erhöhte Sicherheitsbedürfnisse, Erdgeschoss-Wohnungen

**RC 4:**
Schutz gegen schweres Gerät (Säge, Schlagaxt, Hammer, Meißel)
Widerstandszeit: Mindestens 10 Minuten
**Empfehlung:** Gewerbeobjekte, hochwertige Wohnungen

**RC 5 und RC 6:**
Höchste Sicherheitsstufen für Banken, Juweliere etc.
Widerstandszeit: 15-20 Minuten
**Für Privathaushalte üblicherweise nicht nötig**

**Wichtig:**
Eine Sicherheitstür ist nur so stark wie ihr schwächstes Glied. Eine RC 3-Tür bringt nichts, wenn daneben ein Fenster ohne Sicherung ist oder der Türrahmen schlecht montiert ist. Gesamtkonzept beachten!`
      },
      {
        title: 'Praktische Umsetzung: Schritt für Schritt',
        content: `So sichern Sie Ihre Tür effektiv:

**Schritt 1: Bestandsaufnahme (kostenlos)**
• Wie alt ist Ihre Tür?
• Welches Schloss ist verbaut?
• Wie stabil sind Türblatt und Rahmen?
• Gibt es bereits Sicherungen?
• Was ist Ihr Budget?

**Schritt 2: Prioritäten setzen**
**Basis-Sicherung (Budget: 150-300 €):**
• Sicherheitszylinder einbauen
• Schließblech verstärken
• Türspion installieren
• Bandsicherung nachrüsten

**Mittel-Sicherung (Budget: 500-800 €):**
• Alles aus Basis-Sicherung
• Zusatzschloss einbauen
• Moderne Mehrfachverriegelung
• Professionelle Montage

**Premium-Sicherung (Budget: 1.500-3.000 €):**
• Komplette Sicherheitstür RC 2 oder RC 3
• Elektronisches Zutrittssystem
• Alarmanlage mit Türkontakt
• Video-Türsprechanlage

**Schritt 3: Fachmann konsultieren**
Ein Sicherheitsberater kommt zu Ihnen nach Hause:
• Analysiert Ihre spezifische Situation
• Zeigt individuelle Schwachstellen auf
• Erstellt einen Maßnahmenplan
• Gibt Kostenvoranschlag
• Viele Beratungen sind kostenlos

**Schritt 4: Förderung beantragen**
• KfW-Programm 455-E "Einbruchschutz"
• Zuschuss bis 1.600 € (ab 500 € Investition)
• Online-Antrag vor Beginn der Maßnahme
• Auch für Mietwohnungen möglich (mit Vermieterzustimmung)

**Schritt 5: Professioneller Einbau**
Lassen Sie Sicherheitstechnik von Fachleuten einbauen:
• Garantie auf Material und Montage
• Fachgerechte Verankerung im Mauerwerk
• Einweisung in die Bedienung
• Wartungshinweise`
      },
      {
        title: 'Verhalten im Alltag: Die besten Tipps',
        content: `Technik allein reicht nicht – auch Ihr Verhalten ist wichtig:

**DO's:**
✓ Immer abschließen, auch bei kurzer Abwesenheit
✓ Anwesenheit simulieren (Zeitschaltuhren für Licht)
✓ Nachbarn informieren bei Urlaub
✓ Rollläden tagsüber offen lassen (geschlossen = Abwesenheitssignal)
✓ Wertsachen außer Sicht lagern
✓ Leiter und Werkzeug wegschließen
✓ Soziale Medien: Keine Urlaubs-Posts in Echtzeit

**DON'Ts:**
✗ Tür nur "zuziehen" statt abschließen
✗ Schlüssel außen verstecken (Fußmatte, Blumentopf)
✗ Urlaub öffentlich in sozialen Medien ankündigen
✗ Leerstehende Garagen oder Schuppen ungesichert lassen
✗ Briefkasten überquellen lassen
✗ Mülltonnen wochenlang draußen stehen lassen
✗ Fremden unkontrolliert Zugang gewähren (z.B. Handwerker ohne Ausweis)

**Bei Urlaub:**
• Brief kasten leeren lassen
• Zeitschaltuhren programmieren (Licht, Radio)
• Rollläden zeitgesteuert bewegen
• Nachbarn bitten, nach dem Rechten zu sehen
• Keine Abwesenheitsnotiz auf dem Anrufbeantworter

**Nachbarschaftshilfe:**
Eine wachsame Nachbarschaft ist oft der beste Schutz. Fremde Personen, unbekannte Fahrzeuge oder verdächtige Aktivitäten sollten aufmerksam wahrgenommen werden.`
      },
      {
        title: 'Unsere Beratung und Service',
        content: `Als lokaler Schlüsseldienst in Dortmund bieten wir umfassende Sicherheitsberatung:

**Kostenlose Erstberatung am Telefon:**
• Welche Sicherung ist für Sie sinnvoll?
• Was kostet die Umsetzung?
• Welche Förderungen können Sie nutzen?
• Wie läuft die Montage ab?

**Vor-Ort-Sicherheitscheck (ab 50 €, anrechenbar):**
• Begutachtung Ihrer Tür und Sicherheitslage
• Identifikation von Schwachstellen
• Individuelle Empfehlungen
• Detaillierter Kostenvoranschlag
• Informationen zu Förderungen

**Einbau durch zertifizierte Techniker:**
• Professionelle Montage aller Sicherheitssysteme
• Verwendung hochwertiger Markenprodukte (ABUS, BURG-WÄCHTER, DOM)
• Fachgerechte Verankerung im Mauerwerk
• Funktionstest und Einweisung
• Garantie auf Material und Arbeit

**Wartung und Service:**
• Regelmäßige Kontrolle der Sicherheitstechnik
• Nachjustierung bei Bedarf
• Austausch von Verschleißteilen
• Beratung zu Updates und Erweiterungen

**Preisbeispiele:**
• Sicherheitszylinder inkl. Einbau: ab 120 €
• Zusatzschloss inkl. Montage: ab 180 €
• Panzerriegel inkl. Montage: ab 350 €
• Komplette Basis-Sicherung: ab 400 €

Rufen Sie uns an unter 0231 39085116 – wir beraten Sie kostenlos und unverbindlich zu Ihren Möglichkeiten. Schützen Sie Ihr Zuhause professionell!`
      }
    ]
  },

  'sicherheitszylinder': {
    sections: [
      {
        title: 'Was ist ein Sicherheitszylinder?',
        content: `Ein Sicherheitszylinder ist ein hochentwickeltes Schließsystem, das speziell zum Schutz vor Einbruch und Manipulation entwickelt wurde. Im Gegensatz zu einfachen Standard-Zylindern verfügt er über zahlreiche Sicherheitsmerkmale, die das Aufbohren, Aufbrechen, Ziehen oder Manipulieren (Lock-Picking) extrem erschweren oder unmöglich machen.

**Der Unterschied zum Standard-Zylinder:**
Ein normaler Schließzylinder, wie er in vielen Wohnungen verbaut ist, bietet nur Basis-Schutz. Er hält einen Laien ohne Werkzeug ab, aber ein versierter Einbrecher öffnet ihn in unter einer Minute. Ein Sicherheitszylinder hingegen widerstehen kann professionellen Aufbrechversuchen 5-15 Minuten oder länger – und das ist entscheidend, denn die meisten Einbrecher geben nach 2-3 Minuten erfolgloser Versuche auf.

**Investition in Sicherheit:**
Ein hochwertiger Sicherheitszylinder kostet zwischen 80-250 €, abhängig von Größe und Sicherheitsstufe. Das klingt zunächst viel, aber diese Investition schützt Ihr Zuhause über viele Jahre. Betrachtet man die durchschnittlichen Schäden eines Einbruchs (materiell und psychisch), amortisiert sich diese Ausgabe schnell.

**Für wen ist ein Sicherheitszylinder wichtig?**
Grundsätzlich empfehlen wir Sicherheitszylinder für:
• Alle Wohnungs- und Hauseingangstüren
• Erdgeschoss-Wohnungen
• Hochwertige Immobilien
• Bereiche mit höherer Einbruchsrate
• Gewerbeobjekte und Büros
• Türen mit wertvollen Gütern dahinter`
      },
      {
        title: 'Aufbau und Funktionsweise',
        content: `Ein Sicherheitszylinder ist ein komplexes mechanisches Präzisionsbauteil:

**Grundaufbau:**
• **Außengehäuse:** Robustes Metallgehäuse, oft mit Bohrschutz
• **Zylinderkern:** Drehbarer Kern, der den Schließmechanismus enthält
• **Stifte:** Präzisions-Stifte in verschiedenen Längen, die nur zum richtigen Schlüssel passen
• **Federn:** Drücken die Stifte zurück in Ausgangsposition

**Wie funktioniert die Schließung?**
Wenn Sie den Schlüssel ins Schloss stecken:
1. Die Zähne des Schlüssels drücken die Stifte auf die exakte Höhe
2. An der sogenannten "Scherlinie" trennen sich Gehäusestifte und Kernstifte
3. Nur wenn alle Stifte an der richtigen Position sind, kann der Kern gedreht werden
4. Die Drehung betätigt den Riegel

**Sicherheitsmerkmale moderner Zylinder:**

**Bohrschutz:**
Gehärtete Stahlstifte oder Keramik-Plättchen im Kern verhindern das Durchbohren. Eine normale Bohrmaschine kommt nicht durch.

**Ziehschutz:**
Spezielle Verankerungen verhindern, dass der Zylinder mit roher Gewalt herausgezogen werden kann.

**Abreißschutz:**
Sollte der überstehende Teil des Zylinders abgebrochen werden, bleibt der Mechanismus trotzdem blockiert und öffnet nicht.

**Picking-Schutz:**
Spezielle Stiftformen, zusätzliche Sperrelemente und Präzisionsfertigung machen das Lockpicking extrem schwierig bis unmöglich.

**Kernziehschutz:**
Verhindert das Herausziehen des Zylinderkerns mit Spezialwerkzeugen.`
      },
      {
        title: 'Sicherheitsstufen und Zertifizierungen',
        content: `Sicherheitszylinder werden nach verschiedenen Normen geprüft und zertifiziert:

**VdS-Klassen (VdS Schadenverhütung):**
Eine der wichtigsten Zertifizierungen in Deutschland.

**VdS Klasse A (Basis):**
• Grundlegender Schutz
• Für Innentüren oder niedrigen Schutzbedarf
• Widerstand gegen einfache Werkzeuge

**VdS Klasse B (Mittel):**
• Erhöhter Schutz
• Empfohlen für Wohnungstüren
• Widerstand gegen professionellere Aufbrechversuche

**VdS Klasse C (Hoch):**
• Höchster Schutz für private Anwendung
• Für hochwertige Objekte und erhöhtes Sicherheitsbedürfnis
• Widerstand gegen Profiwerkzeug

**DIN-Normen:**

**DIN 18252:**
Definiert Anforderungen an Schließzylinder für Gebäude-Eingangstüren. Unterscheidet Sicherheitsstufen 0-6.

**EN 1303:**
Europäische Norm für Schließzylinder:
• Prüfung auf Korrosionsbeständigkeit
• Dauerhaltbarkeit
• Widerstand gegen Angriffe
• Schlüsselführung und Bedienungskomfort

**Sicherheitskarte:**
Hochwertige Zylinder werden mit einer Sicherheitskarte ausgeliefert:
• Nur mit dieser Karte können Nachschlüssel angefertigt werden
• Schutz vor unbefugtem Kopieren
• Persönliche Registrierung beim Hersteller
• Wichtig: Sicherheitskarte gut aufbewahren!

**BKA-anerkannt:**
Das Bundeskriminalamt erkennt bestimmte Zylinder als besonders sicher an und empfiehlt sie aktiv.`
      },
      {
        title: 'Die besten Marken und Modelle',
        content: `Welcher Sicherheitszylinder ist der richtige für Sie?

**Premium-Segment (150-250 € pro Zylinder):**

**DOM ix 6SR:**
• Einer der sichersten Zylinder auf dem Markt
• Mechanischer und elektronischer Kopierschutz
• Bohr-, Zieh- und Picking-Schutz
• Millionenfache Variationen
• VdS Klasse C, BKA-anerkannt

**EVVA MCS:**
• Magnetcode-System
• Extrem hoher Manipulationsschutz
• Über 1 Milliarde Schließkombinationen
• VdS Klasse C
• 10 Jahre Garantie

**BURG-WÄCHTER Karat:**
• Mehrfach zertifiziert (VdS, DIN, BKA)
• Bohr-, Zieh- und Picking-Schutz
• Wendeschlüssel (von beiden Seiten einsteckbar)
• Moderne Optik

**Mittel-Segment (80-150 € pro Zylinder):**

**ABUS EC660:**
• Sehr gutes Preis-Leistungs-Verhältnis
• VdS Klasse B
• Code-Card-System gegen unerlaubtes Kopieren
• Notfunktion: Von innen immer öffenbar

**ABUS D6X:**
• Bohr- und Ziehschutz
• Wendeschlüssel
• Sehr glatte Laufverhalten
• Gute Allround-Lösung

**ISEO F6:**
• Italienische Qualität
• 6-Stift-System
• Solider Schutz für Standard-Anforderungen
• Verschiedene Längen erhältlich

**Basis-Segment (50-80 € pro Zylinder):**

**ABUS EC550:**
• Bohrschutz
• Solide Verarbeitung
• Für geringe bis mittlere Sicherheitsanforderungen
• Guter Einstieg in Sicherheitstechnik

**Empfehlung:**
Für Wohnungs- und Haustüren empfehlen wir mindestens VdS Klasse B. Bei erhöhtem Schutzbedarf (Erdgeschoss, Einbruchs-gefährdete Gegend, hochwertige Einrichtung) sollte es VdS Klasse C sein.`
      },
      {
        title: 'Einbau und Montage',
        content: `Ein Sicherheitszylinder muss fachgerecht eingebaut werden:

**Schritt 1: Ausmessen**
• Genaues Ausmessen des alten Zylinders (siehe Ratgeber "Schließzylinder ausmessen")
• Innen- und Außenmaß getrennt notieren
• Position der Befestigungsschraube markieren

**Schritt 2: Alten Zylinder ausbauen**
• Tür öffnen
• Stiftschraube an der Stirnseite lösen
• Schlüssel leicht drehen und Zylinder herausziehen

**Schritt 3: Überstandslänge prüfen**
**Wichtig für Sicherheit:**
Der Zylinder sollte **maximal 3mm** über den Beschlag hinausragen. Ein längerer Überstand bietet Angriffsfläche für Aufbrechversuche. Bei zu viel Überstand:
• Kürzeren Zylinder bestellen, oder
• Sicherheitsrosette verwenden (schützt den überstehenden Teil)

**Schritt 4: Neuen Zylinder einbauen**
• Zylinder mit leicht gedrehtem Schlüssel einführen
• Darauf achten, dass er gerade sitzt
• Stiftschraube wieder eindrehen (nicht überdrehen!)

**Schritt 5: Funktion testen**
• Von beiden Seiten mehrfach testen
• Schlüssel muss leicht drehen
• Riegel muss sanft ein- und ausfahren
• Keine Blockade oder schwere Stellen

**Häufige Einbau-Fehler:**

**Fehler 1: Falsche Länge**
Zu kurzer Zylinder: Schloss greift nicht richtig
Zu langer Zylinder: Angriffsfläche für Einbrecher

**Fehler 2: Stiftschraube zu fest angezogen**
Die Schraube darf nicht auf den Zylinder drücken, sonst klemmt der Mechanismus

**Fehler 3: Billige Schrauben verwendet**
Die Befestigungsschraube sollte gehärtet sein. Bei Billigschrauben kann der Zylinder herausgebrochen werden.

**Professioneller Einbau:**
Wir empfehlen, Sicherheitszylinder von einem Fachmann einbauen zu lassen:
• Garantie auf Funktion
• Keine Beschädigungen beim Einbau
• Beratung zur optimalen Länge
• Einweisung in Bedienung und Pflege
• Kostenrahmen: 40-60 € Montage`
      },
      {
        title: 'Wartung und Pflege',
        content: `Ein Sicherheitszylinder ist ein Präzisionsbauteil und braucht regelmäßige Pflege:

**Dos and Don'ts:**

**DO's:**
✓ 2-3x pro Jahr Graphit-Spray ins Schloss sprühen (kein Öl!)
✓ Schlüssel sauber halten (Staub und Schmutz entfernen)
✓ Im Winter bei Frostgefahr: Türschloss-Enteiser parat haben
✓ Leichtgängigkeit regelmäßig prüfen
✓ Bei Problemen sofort Fachmann rufen

**DON'Ts:**
✗ Niemals Öl oder WD-40 verwenden (verklebt und zieht Schmutz an)
✗ Keine Gewalt bei Schwergängigkeit anwenden
✗ Keine spitzen Gegenstände ins Schloss stecken
✗ Zylinder nicht mit Wasser reinigen

**Probleme und Lösungen:**

**Problem: Schlüssel dreht schwer**
• Graphit-Spray anwenden
• Schlüssel reinigen
• Eventuell Zylinder vom Fachmann reinigen lassen

**Problem: Schlüssel klemmt**
• Nicht mit Gewalt drehen!
• Graphit anwenden und vorsichtig probieren
• Bei anhaltendem Problem: Zylinder austauschen

**Problem: Im Winter eingefroren**
• Türschloss-Enteiser verwenden
• Alternativ: Schlüssel kurz mit Feuerzeug erwärmen
• Niemals mit Gewalt öffnen

**Lebensdauer:**
Ein hochwertiger Sicherheitszylinder hält bei guter Pflege 15-25 Jahre. Allerdings entwickelt sich die Sicherheitstechnik weiter – ein Zylinder, der vor 20 Jahren als sicher galt, bietet heute eventuell nicht mehr zeitgemäßen Schutz. Wir empfehlen, Zylinder alle 10-15 Jahre auf den aktuellen Stand der Technik zu prüfen.`
      },
      {
        title: 'Unsere Beratung und Service',
        content: `Als Experten für Sicherheitstechnik beraten wir Sie umfassend:

**Kostenlose Beratung:**
• Welcher Zylinder passt zu Ihrer Tür?
• Welche Sicherheitsstufe brauchen Sie?
• Welche Marke empfehlen wir für Ihren Bedarf?
• Was kostet die komplette Umsetzung?

**Unser Service:**
• Vor-Ort-Aufmaß (damit der Zylinder perfekt passt)
• Große Auswahl an hochwertigen Marken-Zylindern
• Professioneller Einbau durch zertifizierte Techniker
• Einweisung in Bedienung und Pflege
• Garantie auf Material und Montage
• Entsorgung des alten Zylinders

**Schließanlagen:**
Sie haben mehrere Türen (Haus, Garage, Keller, Gartentür)?  
Wir richten Schließanlagen ein:
• Ein Schlüssel für alle Türen
• Hierarchische Systeme (Hauptschlüssel + Einzelschlüssel)
• Optimal für Mehrfamilienhäuser oder Gewerbe
• Spart Schlüsselbund und erhöht Komfort

**Preis beispiele:**
• ABUS EC660 (VdS B) inkl. Einbau: ab 150 €
• DOM ix 6SR (VdS C) inkl. Einbau: ab 220 €
• EVVA MCS (VdS C) inkl. Einbau: ab 250 €
• Nachschlüssel: ab 25 € (mit Sicherheitskarte)

**Not-Service:**
Zylinder defekt oder Schlüssel verloren? Wir helfen 24/7:
• Schnelle Anfahrt (15-30 Min in Dortmund)
• Sofortiger Austausch vor Ort
• Große Auswahl an Zylindern im Fahrzeug
• Festpreise auch im Notdienst

Rufen Sie uns an unter 0231 39085116 – wir finden den perfekten Sicherheitszylinder für Ihr Zuhause!`
      }
    ]
  }
};
